var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00005 3.75V5.25C6.82284 5.25 5.86484 6.2595 5.86484 7.5H4.44137C4.44137 5.43225 6.0378 3.75 8.00005 3.75ZM1.98233 14.25L3.72964 11.8822V7.5C3.72964 5.01825 5.64492 3 8.00005 3C10.3552 3 12.2705 5.01825 12.2705 7.5V11.8822L14.0178 14.25H1.98233ZM8.00005 16.5C7.38796 16.5 6.82569 16.2142 6.43423 15.75H9.56586C9.17441 16.2142 8.61214 16.5 8.00005 16.5ZM15.812 14.2365L13.6939 11.3678V7.5C13.6939 4.9755 12.2043 2.814 10.1046 1.92975C9.9559 0.8415 9.07335 0 8.00005 0C6.92675 0 6.0442 0.8415 5.89545 1.92975C3.79583 2.814 2.30617 4.9755 2.30617 7.5V11.3678L0.186625 14.238C-0.0219135 14.5238 -0.0589237 14.9018 0.091964 15.2257C0.242852 15.549 0.548186 15.75 0.89053 15.75H4.76593C5.32321 17.0985 6.58298 18 8.00005 18C9.41711 18 10.6769 17.0985 11.2342 15.75H15.1096C15.4519 15.75 15.7572 15.549 15.9081 15.2257C16.059 14.9018 16.022 14.5238 15.812 14.2365Z",
    fill: "#1D1D1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.87e86641c7b9f22b1f1217868510c88a.svg";
export { ForwardRef as ReactComponent };